export default __webpack_public_path__ + "static/media/affiliate-marketing.da89374c.png";